// Client-side image helpers for receipt scanning: shrink big camera photos
// before upload so the request stays small and the AI call is fast.

const MAX_EDGE = 1920; // longest side, px

// Resize/compress a File to a JPEG Blob, targeting <= maxSizeMB.
export async function compressImage(file, maxSizeMB = 2) {
  const img = await loadImage(file);

  let { width, height } = img;
  if (Math.max(width, height) > MAX_EDGE) {
    const scale = MAX_EDGE / Math.max(width, height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  let blob = await canvasToBlob(canvas, 0.85);
  if (blob && blob.size > maxSizeMB * 1024 * 1024) {
    const smaller = await canvasToBlob(canvas, 0.7);
    if (smaller) blob = smaller;
  }
  return blob || file;
}

// Read a File/Blob as a pure base64 string (data-URL prefix stripped).
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || '';
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function getMediaType(file) {
  const t = (file && file.type) || '';
  if (t === 'image/png') return 'image/png';
  if (t === 'image/webp') return 'image/webp';
  if (t === 'image/gif') return 'image/gif';
  return 'image/jpeg'; // default (compression outputs JPEG)
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

function canvasToBlob(canvas, quality) {
  return new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), 'image/jpeg', quality);
  });
}
